export default __webpack_public_path__ + "static/images/invitation-inset.71772c50.png";